import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import DAWPage from "./pages/DAWPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import TrainingLabPage from "./pages/TrainingLabPage";
import BillingSuccessPage from "./pages/BillingSuccessPage";
import CommunityPage from "./pages/CommunityPage";
import BeatsPage from "./pages/BeatsPage";
import BeatDetailPage from "./pages/BeatDetailPage";
import AdminBeatsPage from "./pages/AdminBeatsPage";
import PurchaseSuccessPage from "./pages/PurchaseSuccessPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import MyBeatsPage from "./pages/MyBeatsPage";
import RequireDawAuth from "./auth/RequireDawAuth";
import { AuthProvider } from "./auth/AuthContext";
import SplashGate from "./components/SplashGate";
import "@/App.css";

// v12.5 — Apply the persisted light/dark theme to <html> at earliest
// possible React mount so no page renders in the wrong theme (avoids
// a "flash of dark" for light-mode users). The theme lives in
// `localStorage.crow_theme` and cascades globally via the invert
// filter defined in index.css.
function useAppliedTheme() {
  useEffect(() => {
    const theme = localStorage.getItem("crow_theme") === "light" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", theme);
    const onStorage = (e) => {
      if (e.key !== "crow_theme") return;
      document.documentElement.setAttribute("data-theme", e.newValue === "light" ? "light" : "dark");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
}

function App() {
  useAppliedTheme();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
        <SplashGate>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/daw" element={<RequireDawAuth><DAWPage /></RequireDawAuth>} />
            <Route path="/admin" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/training" element={<TrainingLabPage />} />
            <Route path="/billing/success" element={<BillingSuccessPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/beats" element={<BeatsPage />} />
            <Route path="/store" element={<Navigate to="/beats" replace />} />
            <Route path="/store/*" element={<Navigate to="/beats" replace />} />
            <Route path="/beats/:artistSlug/:nameSlug" element={<BeatDetailPage />} />
            <Route path="/admin/beats" element={<AdminBeatsPage />} />
            <Route path="/purchase/success/:purchaseId" element={<PurchaseSuccessPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/my-beats" element={<MyBeatsPage />} />
          </Routes>
        </SplashGate>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
